import { memo } from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@artprov/design-system';

/**
 * Celda de Grupo para Matching Judicial.
 * Muestra un Badge accent con state information (P) o warning (D).
 * Soporta mostrar texto completo (Principal/Derivados) o abreviado (P/D).
 */
const getState = (value) => {
    if (value === 'D') return 'warning';
    if (value === 'P') return 'information';
    return null;
};

const getLabel = (value, showFullText) => {
    if (value === 'P') return showFullText ? 'Principal' : 'P';
    if (value === 'D') return showFullText ? 'Derivado' : 'D';
    return value;
};

export const GrupoCell = memo(function GrupoCell({ value, showFullText = false }) {
    const state = getState(value);

    return (
        state && (
            <Badge variant="accent" state={state} className="!border-l-8">
                {getLabel(value, showFullText)}
            </Badge>
        )
    );
});

GrupoCell.propTypes = {
    value: PropTypes.string,
    showFullText: PropTypes.bool,
};
